import { SearchResult } from '@securecore-new-application/securecore-datacore';

import { DotSeparator } from '../DotSeparator';
import Icon, { IconTypes } from '../Icon/Icon';
import { SearchHighlight } from '../SearchHighlight';
import { theme } from '../themes/default';
import {
  SearchItemImageWrapper,
  SearchItemInfo,
  SearchItemMeta,
  SearchItemMetaPiece,
  SearchItemTitle,
  SearchItemWrapper,
} from './SearchItem.styles';

interface SearchItemProps {
  searchItem: SearchResult;
  query: string;
}

const SEARCH_ICON_SIZE = 18;
const searchIcons: Record<string, IconTypes> = {
  Property: IconTypes.Property,
  Building: IconTypes.Buildings,
  TenantSpace: IconTypes.DotsTriangle,
  Attachment: IconTypes.Files,
};

export function SearchItem({ searchItem, query }: SearchItemProps) {
  const icon = searchIcons[searchItem.entityName] || IconTypes.Dashboard;

  return (
    <SearchItemWrapper>
      <SearchItemImageWrapper>
        {icon && <Icon icon={icon} fillColor={theme.darkGrey} width={SEARCH_ICON_SIZE} height={SEARCH_ICON_SIZE} />}
      </SearchItemImageWrapper>
      <SearchItemInfo>
        <SearchItemTitle>
          <SearchHighlight search={query}>{searchItem.name}</SearchHighlight>
        </SearchItemTitle>
        <SearchItemMeta>
          {searchItem.parentEntityName && (
            <>
              <SearchItemMetaPiece>{searchItem.parentEntityName}</SearchItemMetaPiece>
              <DotSeparator />
            </>
          )}
          <SearchItemMetaPiece>{searchItem.entityName}</SearchItemMetaPiece>
        </SearchItemMeta>
      </SearchItemInfo>
    </SearchItemWrapper>
  );
}
